import { forwardRef, Icon, Input, InputGroup, InputLeftElement, InputProps } from "@chakra-ui/react";

export type CustomInputProps = Omit<InputProps, "value" | "onChange"> & {
  value: string;
  onChange: (value: string) => void;
  onInputClick?: () => void;
  leftIcon?: React.ElementType;
  children?: React.ReactNode;
};

export const CustomInput = forwardRef<CustomInputProps, "input">(
  ({ onChange, onInputClick, value, children, leftIcon, ...props }: CustomInputProps, ref) => {
    const handleChange = (event: { target: { value: string } }) => onChange(event.target.value);
    return (
      <InputGroup width={props.width} maxW="100%">
        {leftIcon && (
          <InputLeftElement h="full" pointerEvents="none">
            <Icon as={leftIcon} color="gray.400" boxSize="18px" />
          </InputLeftElement>
        )}
        <Input
          ref={ref}
          onChange={handleChange}
          onClick={onInputClick}
          value={value}
          {...props}
          h={props.h ?? "48px"}
          pl={leftIcon ? "44px" : props.pl}
          fontSize="15px"
          bg="white"
          borderRadius="12px"
          borderWidth="1.5px"
          borderColor="rgba(67,0,152,0.16)"
          boxShadow="0 1px 2px rgba(67,0,152,0.04)"
          _placeholder={{ color: "gray.400", fontSize: "14px" }}
          _hover={{ borderColor: "rgba(67,0,152,0.32)" }}
          _focusVisible={{ borderColor: "primary", boxShadow: "0 0 0 3px rgba(67,0,152,0.12)" }}
        />
        {children}
      </InputGroup>
    );
  }
);
